import { render, staticRenderFns } from "./OverTheCounter.vue?vue&type=template&id=06c70578&scoped=true"
import script from "./OverTheCounter.vue?vue&type=script&lang=js"
export * from "./OverTheCounter.vue?vue&type=script&lang=js"
import style0 from "./OverTheCounter.vue?vue&type=style&index=0&id=06c70578&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c70578",
  null
  
)

export default component.exports